function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 34a23.5 12.5 0 01-23.5 12.5A23.5 12.5 0 011 34a23.5 12.5 0 0123.5-12.5A23.5 12.5 0 0148 34zM50 28s1.096-.619 1.912-.619 1.912.619 1.912.619l-1.53 6.19h-.765zM50 40.381s1.096.619 1.912.619 1.912-.619 1.912-.619l-1.53-6.19h-.765z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M48 34h7M40 24.5l5-3.5h7l-5 9M40 43.5l5 3.5h7l-5-9"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 34,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 34,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34.5,
  cy: 34,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 21.3v-1c0-1.108.892-2 2-2h6c1.108 0 2 .892 2 2v1M27 18.1V7c0-1.108-.892-2-2-2h-6c-1.108 0-2-3-2.095 2S17.892 9 19 9h4v9.1"
})));

var SvgSubmarine = function SvgSubmarine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubmarine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Submarine.456894cc.svg";
export { ForwardRef as ReactComponent };